import { combineReducers } from "redux";

import { applicationSlice } from "./slice";

export const applicationReducer = combineReducers({
  [applicationSlice.name]: applicationSlice.reducer,
});
